import React from "react";

import nucleusTeq_reprint_page1 from "../../assets/images/home/pdf/nucleusTeq_reprint_page-0001.jpg";
import nucleusTeq_reprint_page2 from "../../assets/images/home/pdf/nucleusTeq_reprint_page-0002.jpg";
import nucleusTeq_reprint_page2_1 from "../../assets/images/home/pdf/nucleusTeq_reprint_page-0002-1.jpg";
import nucleusTeq_reprint_page2_2 from "../../assets/images/home/pdf/nucleusTeq_reprint_page-0002-2.jpg";
import nucleusTeq_certificate_page1 from "../../assets/images/home/pdf/nucleusTeq_certificate_page-0001.jpg";
import nucleusTeq_award_logo_page1 from "../../assets/images/home/pdf/nucleusTeq_award_logo_page-0001.jpg";
import { CommonButton } from "../../Components/CommonButton";
import { BsArrowRight } from "react-icons/bs";

const CioReview = () => {
  return (
    <>
      {/* <div style={{width : "100%", display:"flex", justifyContent : "center", alignItems : "center", backgroundColor : "#FFF"}}>
      <img src={nucleusTeq_award_logo_page1}  style={{height : "80vh"}} />
      </div> */}
      <img src={nucleusTeq_reprint_page2_1} width={"100%"} />
      <img src={nucleusTeq_reprint_page2_2} width={"100%"} />
      {/* <img src={nucleusTeq_reprint_page2} width={"100%"} /> */}
      <CommonButton
        buttonText="Read More"
        link={"https://www.cioreview.com/nucleusteq-nuodata"}
        icon={<BsArrowRight />}
        target="_blank"
      />
      <br />
      <img src={nucleusTeq_reprint_page1} width={"100%"} />
      {/* <img src={nucleusTeq_certificate_page1} width={"100%"} /> */}
    </>
  );
};

export default CioReview;
